import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import * as _ from 'underscore';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { MAP_CONSTANTS, CONSTANTS } from '../../../analytics/constants/analytics.constants';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { MapComponentService, MapLegendItem } from '../map/map.component.service';
import { MapComponent } from '../map/map.component';
import { AnalyticsDataChachingService } from '../../../analytics/services/analytics.datacaching.service';

@Component({
	selector: 'app-map-v5',
	templateUrl: './map-v5.component.html',
	styleUrls: ['./map-v5.component.css'],
	providers: [MapComponentService]
})
export class MapV5Component extends MapComponent implements OnInit, AfterViewInit, WidgetCore, OnDestroy {
	public withDeprecatedField: boolean = true;
	public popup: any;
	protected mapStyle = 'mapbox://styles/freq-e-deek/cjv6zgkb9aqn21fpaujnfz8go';
	protected miniMapStyle = 'mapbox://styles/freq-e-deek/cjv6zgkb9aqn21fpaujnfz8go';
	protected mapFillColor = 'rgba(31, 119, 188, 0.7)';
	public enableZone: boolean = false;
	public enableZip: boolean = false;
	public colorPalette: ColorPalette;
	protected PRODUCTS: any = {
		ALL: 'all',
		DISPLAY: 'display'
	};

	public circleMarkerStyles = {
		'circle-color': '#1f77bc',
		'circle-radius': 5,
		'circle-stroke-color': '#FFF',
		'circle-stroke-width': 1
	};

	public minimapCircleStyle = {
		'circle-color': '#cbe0ef',
		'circle-radius': 5,
		'circle-stroke-color': '#fff',
		'circle-stroke-width': 1
	};
	/**
	 *
	 * @type {{productName: string; productKey: string; isDisabled: boolean; isSelected: boolean}[]}
	 */
	protected DEFAULT_PRODUCTS = [
		{
			productName: 'SEM',
			productKey: MAP_CONSTANTS.STATE.SEM,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasSem'],
			order: 3
		},
		{
			productName: 'Television',
			productKey: MAP_CONSTANTS.STATE.TELEVISION,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasTelevision'],
			order: 5
		}
	];
	range: any;

	/**
	 *
	 * @type {{productName: string; productKey: string; showInLegend: boolean; show: boolean; isDisabled: boolean; isSelected: boolean}[]}
	 */
	// protected GF_PRODUCTS = [];

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService,
		protected mapComponentService: MapComponentService,
		protected AnalyticsDataChachingService: AnalyticsDataChachingService
	) {
		super(analyticsService, analyticsDataModel, colorUtilityService, mapComponentService, AnalyticsDataChachingService);
	}

	ngOnInit() {
		super.ngOnInit();
		// this.range = this.analyticsService.checkDateRange(this.analyticsService.deprecated_date_avg_position);
		// if(this.range === 'WITHIN'){
		// 	this.withDeprecatedField = true;
		// }else{
		// 	this.withDeprecatedField = false;
		// }
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
	}
	ngAfterViewInit() {
		super.ngAfterViewInit();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	get selectedState() {
		return this.mapComponentService.selectedState;
	}

	protected displayLocationDataOnMouseover(regionObj: any) {
		super.displayLocationDataOnMouseover(regionObj, {});
		const isTVactive = !!this.mapObj.legend.filter((item) => item.isSelected && item.productKey === 'cox_tv').length;
		const deselectedLegends = this.mapObj.legend.filter(
			(item) => !item.isSelected && !item.isDisabled && item.productKey !== 'cox_tv'
		);
		const allLegends = this.mapObj.legend.filter((item) => !item.isDisabled && item.productKey !== 'cox_tv');
		if (
			(parseInt(regionObj.sem) ||
				parseInt(regionObj.display) ||
				parseInt(regionObj.ctv) ||
				parseInt(regionObj.preroll)) &&
			deselectedLegends.length !== allLegends.length
		) {
			this.enableZip = true;
		} else {
			this.enableZip = false;
		}
		if (parseInt(regionObj.tv) && isTVactive) {
			this.enableZone = true;
		} else {
			this.enableZone = false;
		}
	}

	get geofenceCenterDetailsForMap() {
		return [
			{
				attribute: 'Impressions',
				value: this.geofenceCenterDetails ? this.formatNumber(this.geofenceCenterDetails.total_impression_sum) : ''
			},
			{
				attribute: 'CTR',
				value: this.geofenceCenterDetails ? this.geofenceCenterDetails.click_through_rate + '%' : ''
			},
			{ attribute: 'Clicks', value: this.geofenceCenterDetails ? this.geofenceCenterDetails.total_click_sum : '' },
			{ attribute: 'Android', value: this.geofenceCenterDetails ? this.geofenceCenterDetails.total_android + '%' : '' },
			{ attribute: 'Apple', value: this.geofenceCenterDetails ? this.geofenceCenterDetails.total_ios + '%' : '' }
		];
	}

	get liftDetails() {
		return [
			{
				attribute: 'Avg Home Value:',
				value: this.formatNumber(this.polygonLayerDetails.avgHomeValue),
				addDollar: true
			},
			{ attribute: 'Median Age:', value: this.polygonLayerDetails.avgMedianAge, addDollar: false },
			{ attribute: 'Avg Income:', value: this.formatNumber(this.polygonLayerDetails.avgIncome), addDollar: true },
			{ attribute: 'Avg# per household:', value: this.polygonLayerDetails.avgOccupancy, addDollar: false }
		];
	}

	get showLegend() {
		return this.selectedState === this.PRODUCTS.ALL || this.selectedState === this.PRODUCTS.DISPLAY;
	}

	formatNumber(value: { toString: () => { replace: (arg0: RegExp, arg1: string) => void } }) {
		return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
	}
}
